type IconName = 'check' | 'arrow' | 'spark' | 'coin' | 'minus' | 'plus' | 'shield' | 'infinity' | 'no-sub'

interface IconProps {
  name: IconName
  size?: number
}

const Icon = ({name, size = 14}: IconProps) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }
  switch (name) {
    case 'check':
      return (
        <svg {...common}>
          <path d="M5 12l5 5L20 7" />
        </svg>
      )
    case 'arrow':
      return (
        <svg {...common}>
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      )
    case 'spark':
      return (
        <svg {...common}>
          <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" />
        </svg>
      )
    case 'minus':
      return (
        <svg {...common}>
          <path d="M5 12h14" />
        </svg>
      )
    case 'plus':
      return (
        <svg {...common}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      )
    case 'shield':
      return (
        <svg {...common}>
          <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      )
    case 'infinity':
      return (
        <svg {...common}>
          <path d="M18.6 7.4c-1.7-1.7-4.5-1.7-6.2 0L7.4 12.6c-1.7 1.7-4.5 1.7-6.2 0c-1.7-1.7-1.7-4.5 0-6.2c1.7-1.7 4.5-1.7 6.2 0L12.6 11.4c1.7 1.7 4.5 1.7 6.2 0c1.7-1.7 1.7-4.5 0-6.2" />
        </svg>
      )
    case 'no-sub':
      return (
        <svg {...common}>
          <rect x="3" y="6" width="18" height="13" rx="2" />
          <path d="M3 10h18M7 15h2M12 15h2" />
          <path d="M5 4l14 16" />
        </svg>
      )
    case 'coin':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M9 12h6M12 9v6" />
        </svg>
      )
    default:
      return null
  }
}

export default Icon
